export default __webpack_public_path__ + "static/media/Spirituality.f2459617.jpg";